<template>
  <img :src="source" :alt="source">
</template>

<script>
export default {
  data() {
    return {
      source: `${process.env.VUE_APP_API_URL}/${this.src}` 
    }
  },

  props: {
    src: {
      default() {
        return ''
      }
    }
  }
}
</script>